<template>
    <UserAvatar :user-info="patient.user">
        <span class="patient-notification--new-msg" v-if="unreadMessagesCount && patient.unread_messages_count">{{ patient.unread_messages_count }}</span>
        <span v-else-if="showLastContactTime" class="patient-notification--last-msg">{{ lastContactTime }}</span>
    </UserAvatar>
</template>

<script>
    export default {
        props: {
            patient: {
                type: Object,
                required: true
            },
            unreadMessagesCount: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        computed: {
            lastContactTime() {
                const diff = moment.duration(moment().diff(moment(this.patient.last_contact)))
                
                let minuteLabel = 'm'
                let hourLabel = 'h'
                let dayLabel = 'd'
                let weekLabel = 't'

                if(this.locale === 'de') {
                    weekLabel = 'w'
                }      
                
                if(diff.asDays() > 1) {
                    if(diff.asDays() < 7) {
                        return Math.round(diff.asDays(), 0) + dayLabel
                    } else {
                        return Math.round(diff.asWeeks(), 0) + weekLabel
                    }
                }

                if(diff.asHours() > 1) {
                    return Math.round(diff.asHours(), 0) + hourLabel
                }

                if(diff.asMinutes() >= 1) {
                    return Math.round(diff.asMinutes(), 0) + minuteLabel
                } else {
                    return 1 + minuteLabel
                }
            },
            showLastContactTime() {
                if(this.user.isCoach && this.patient.last_contact) {
                    const diff = moment.duration(moment().diff(moment(this.patient.last_contact)))

                    if(this.patient.inactivated_at === "" && !this.patient.is_frozen && diff.asMinutes() > 1) {
                        return true
                    }
                }

                return false
            }
        }
    }
</script>
